import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverHaltEntity } from '../../domain/entities/DriverHaltEntity'

export class DriverHaltModel extends DriverHaltEntity {
  constructor(dataDto: DriverHaltModel) {
    super()
    mapEntityProperties<DriverHaltEntity>(this, dataDto)
  }
}
